export default "__VITE_ASSET__Bh_Blxn6__"